export enum InspectTab {
  Data = 'data',
  Meta = 'meta', // When result metadata exists
  Error = 'error',
  Stats = 'stats',
  JSON = 'json',
  Query = 'query',
  Actions = 'actions', // ALPHA!
  Help = 'help', // get info required for support+debugging
}
